import {ChildFolderDtoFragment} from "../../../_gql/graphql";
import {Menu} from "@mantine/core";
import {Link} from "react-router-dom";
import React from "react";

export const ContextFolderMenu = ({folder}: { folder: ChildFolderDtoFragment }) => {
    return <Menu.Dropdown>
        <Menu.Item component={Link} to={'/tree/folder/' + folder.id}>Add new publication</Menu.Item>
    </Menu.Dropdown>
}